import * as React from 'react';
import './App.css';
import logo from './logo.svg';

import Chart from './Chart';

import { autobind } from '@uifabric/utilities/lib';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Pivot, PivotItem, PivotLinkSize } from 'office-ui-fabric-react/lib/Pivot';
import { TextField } from 'office-ui-fabric-react/lib/TextField';



interface IAppState {
  color: string;
  text: string;
  data: Array<[number, number]>;
  selectedKey: string;
}

class App extends React.Component<{}, IAppState> {

  constructor(props:{}) {
    super(props);

    this.state = { color: '#ffffff', text: '', data: [], selectedKey: 'graph' };

    // this.onColorChanged = this.onColorChanged.bind(this);
  }

  public render() {

    return (
      <div className="App" >

        <Pivot linkSize={PivotLinkSize.large} selectedKey={this.state.selectedKey} onLinkClick={this.onLinkClick}>
          <PivotItem linkText='Graph' itemKey='graph'>
            <div style={{ margin: 10 }}>
              <div style={{ textAlign: 'left', marginBottom: 10 }}>
                <Label >Draw on the chart below to change the absorbance spectrum.</Label>
                <Label >The background color represents the color of the sample with the given absorbance.</Label>
              </div>
              <div style={{ display: 'block' }}>
                <Chart width={400} height={400} colorChanged={this.onColorChanged} data={this.state.data} />
              </div>
            </div>
          </PivotItem>
          <PivotItem linkText='Import Data' itemKey='data'>
            <div style={{ margin: 10 }}>
              <Label>Copy actual absorbance spectra data and plot it.  One data point per line, wavelength followed by absorbance separated by whitespace.</Label>
              <TextField
                label='Paste data here'
                multiline={true}
                rows={10}
                value={this.state.text}
                onChanged={this.onTextFieldChanged} />
                <DefaultButton
                  text='Clear'
                  onClick={this.onClearData} />
              <PrimaryButton
                text='Process Data'
                onClick={this.processData}
              />
            </div>
          </PivotItem>
        </Pivot>
      </div>
    );
  }

  @autobind
  private onLinkClick(item: PivotItem) {
    this.setState({ selectedKey: item.props.itemKey as string });
  }

  @autobind
  private onTextFieldChanged(value: string) {
    this.setState({ text: value });
  }

  @autobind
  private onColorChanged(hexColor: string) {
    this.setState({ color: hexColor });
  }

  @autobind
  private onClearData(){
    this.setState({text:''});
  }

  @autobind
  private processData() {
    const data: Array<[number, number]> = [];
    const lines = this.state.text.split('\n');
    for (const line of lines) {
      const arr = line.replace(/\s+/g, " ").replace(/^\s|\s$/g, "").split(" ");
      const x = Number.parseFloat(arr[0]);
      const y = Number.parseFloat(arr[1]);
      if (!isNaN(x) && !isNaN(y)){
        data.push([x, y]);
      }
    }
    // console.log(data);

    const separation = 5;
    const boundary = separation / 2;
    const goodData: Array<[number, number]> = [];
    let currentWavelength = 360;
    let sumAbsorbance = 0;
    let count = 0;
    for (const point of data) {
      if (Math.abs(point[0] - currentWavelength) <= boundary) {
        sumAbsorbance += point[1];
        count++;
      } else {
        // add point
        if (count === 0) {
          goodData.push([currentWavelength, data[0][1]]);
        } else {
          goodData.push([currentWavelength, sumAbsorbance / count]);
        }
        // while (Math.abs(point[0]-currentWavelength) > boundary){
        currentWavelength += separation;
        if (currentWavelength > 760){
          break;
        }
        // }
        sumAbsorbance = point[1];
        count = 1;
      }
    }
    while (currentWavelength < 760){      
      goodData.push([currentWavelength, goodData[goodData.length-1][1]]);
      currentWavelength+= separation;
    }
    // console.log(goodData);
    this.setState({ selectedKey: 'graph', data: goodData });
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx